// UploadAttachmentModal.jsx
import Modal from "react-modal";
import { handleUpload } from "../FileDownloadManager";
import { attachZip } from "../../../API/attachZip";

const UploadAttachmentModal = ({
  isOpen,
  onClose,
  fileState,
  documentInfo,
  attachmentTypes,
  t,
}) => {
  const {
    selectedFile,
    setSelectedFile,
    fileExtension,
    setFileExtension,
    errorMessage,
    setErrorMessage,
  } = fileState;

  const { instanceId, selectedDocumentId, modelId } = documentInfo;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();
    setSelectedFile(file);
    setFileExtension(ext);
    setErrorMessage("");
  };

  const handleSubmit = () => {
    if (!selectedFile) {
      setErrorMessage(t("No files added."));
      return;
    }
    if (!attachmentTypes.includes(fileExtension)) {
      setErrorMessage(t("Unauthorized extension :") + ` ${fileExtension}`);
      return;
    }
    setErrorMessage("");
    handleUpload(
      selectedFile,
      instanceId,
      selectedDocumentId,
      modelId,
      fileExtension,
      attachZip,
      onClose,
      setSelectedFile
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          backgroundColor: "#f7f7f7",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "500px",
          maxHeight: "280px",
          margin: "auto",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <div>
        <h2 style={{ marginBottom: "15px" }}>
          {t("Upload attachement")}
        </h2>
        <input
          type="file"
          onChange={handleFileChange}
          style={{
            display: "block",
            margin: "10px 0",
            padding: "10px",
            fontSize: "14px",
          }}
        />
        <p>          
          {t("The authorized extensions are : ")}
          {attachmentTypes.join(", ")}
        </p>
        <p style={{ color: "red" }}>{errorMessage}</p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 15px",
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {t("Upload")}
          </button>
          <button
            onClick={() => {
              onClose();
              setErrorMessage("");
            }}
            style={{
              padding: "10px 15px",
              backgroundColor: "#ccc",
              color: "#000",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {t("Close")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadAttachmentModal;
